// @ts-check
import {memo, shapeComponent, ShapeComponent, Text, useI18n, View} from "shared/base"
import Link from "@kaspernj/api-maker/build/link"
import PageContentsPresentation from "components/page-contents/presentation"
import React from "react"
import Routes from "shared/routes"
import setLayout from "shared/set-layout"

/** @typedef {object} RoutesEmbedWelcomeProps */
/** @typedef {object} RoutesEmbedWelcomeState */

/**
 * @extends {ShapeComponent<RoutesEmbedWelcomeProps, RoutesEmbedWelcomeState>}
 */
class RoutesEmbedWelcome extends ShapeComponent {
  render() {
    setLayout("embed")
    const {t} = useI18n({namespace: "js.routes.embed.welcome"})

    return (
      <View
        style={this.rootContainerStyle ||= {
          backgroundColor: "#ffffff",
          minHeight: "100vh",
          paddingTop: 64,
          paddingBottom: 64,
          paddingHorizontal: 16,
          alignItems: "center",
          justifyContent: "center"
        }}
        testID="routes--embed--welcome"
      >
        <View style={this.contentContainerStyle ||= {maxWidth: 640, width: "100%", alignItems: "center"}}>
          <View style={this.contentBlockStyle ||= {marginBottom: 32, alignItems: "center"}}>
            <PageContentsPresentation identifier="embed_signup_welcome_se" />
          </View>
          <View style={this.buttonContainerStyle ||= {marginTop: 8}}>
            <Link target="_blank" testID="open-home-button" to={Routes.userRootPath({locale: "se"})}>
              <View
                style={this.buttonStyle ||= {
                  backgroundColor: "#2c2c96",
                  borderRadius: 30,
                  paddingVertical: 14,
                  paddingHorizontal: 32,
                  minWidth: 220,
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <Text style={this.buttonTextStyle ||= {color: "#ffffff", fontWeight: "700", fontSize: 16}}>
                  {t(".open_woof")}
                </Text>
              </View>
            </Link>
          </View>
        </View>
      </View>
    )
  }
}

export default memo(shapeComponent(RoutesEmbedWelcome))
